<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-menu"></i> Pet
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.tipo.$error }"
                                >
                                    <label>Espécie*</label>
                                    <select2
                                        :options="tipos"
                                        v-model="model.tipo"
                                        placeholder="Selecione a espécie"
                                        :select-option="true"
                                    >
                                        <option value selected></option>
                                    </select2>
                                </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.id_raca.$error }"
                                >
                                    <label>Raça</label>
                                    <Select
                                        v-model="model.id_raca"
                                        :options="racas"
                                        opt-text="nome"
                                        placeholder="Selecionar"
                                        :select-option="true"
                                    >
                                        <option value selected></option>
                                    </Select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Nascimento*</label>
                                    <input-datepicker
                                        :disabled="false"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        :required="true"
                                        v-model="model.nascimento"
                                    ></input-datepicker>
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.tamanho.$error }"
                                >
                                    <label>Tamanho*</label>
                                    <Select2
                                        v-model="model.tamanho"
                                        :options="tamanhos"
                                        opt-id="id"
                                        opt-text="text"
                                    ></Select2>
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.sexo.$error }"
                                >
                                    <label>Sexo*</label>
                                    <Select2
                                        v-model="model.sexo"
                                        :options="sexos"
                                        opt-id="id"
                                        opt-text="text"
                                    ></Select2>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{'has-danger': $v.model.corPelo.$error }"
                                >
                                    <label>Cor do Pelo*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.corPelo"
                                        @input="$v.model.corPelo.$touch()"
                                    />
                                </div>
                                <div class="col-md-3 align-self-center">
                                    <label>Está com vacinação em dia?*</label>
                                    <br />
                                    <input-toggle
                                        v-model="model.vacinacaoEmDia"
                                        :value="model.vacinacaoEmDia"
                                    ></input-toggle>
                                </div>
                                <div class="col-md-3 align-self-center">
                                    <label>Doença ou lesão preexistente?*</label>
                                    <br />
                                    <input-toggle
                                        v-model="model.doencaLesao"
                                        :value="model.doencaLesao"
                                    ></input-toggle>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div v-if="model.doencaLesao" class="col-md-4">
                                    <label>Descrição da doença ou lesão*</label>
                                    <textarea
                                        rows="6"
                                        cols="60"
                                        type="text"
                                        maxlength="1000"
                                        class="form-control"
                                        v-model="model.doencaLesaoDescricao"
                                    />
                                </div>
                            </div>
                            <file-image v-model="file" :arquivo="model.arquivo"></file-image>
                        </div>

                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'list-pet' }" class="btn btn-link">Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import SelectClient from "../../components/Input/SelectClient";
import Select2 from "../../components/Input/Select2";
import SelectApi from "../../components/Input/SelectApi";
import Select from "../../components/Input/Select";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
export default {
    components: {
        SelectClient,
        FileImage,
        Select2,
        SelectApi,
        Select
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                tipo: "",
                corPelo: "",
                nascimento: moment().format("YYYY-MM-DD"),
                tamanho: "",
                sexo: "",
                vacinacaoEmDia: true,
                doencaLesao: true,
                doencaLesaoDescricao: null,
                peso: 1,
                altura: 1,
                observacao: "",
                protegido: 1,
                idCliente: null,
                id_raca: "",
                arquivo: null
            },
            file: null,

            tipos: [{ id: "C", text: "Cão" }, { id: "G", text: "Gato" }],
            tamanhos: [
                { id: "P", text: "Pequeno" },
                { id: "M", text: "Médio" },
                { id: "G", text: "Grande" }
            ],

            sexos: [{ id: "M", text: "Macho" }, { id: "F", text: "Fêmea" }],
            racas: []
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                tipo: {
                    required
                },
                id_raca: {
                    required
                },
                nascimento: {
                    required
                },
                tamanho: {
                    required
                },
                sexo: {
                    required
                },
                corPelo: {
                    required
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }
            if (vm.model.doencaLesao == true) {
                if (!vm.model.doencaLesaoDescricao) {
                    this.$v.model.$touch();
                    this.$notify.warning(
                        "Atenção!",
                        "Descrição da doença ou lesão é obrigatório."
                    );
                    return;
                }
            }

            this.$loading.show(true);

            try {
                vm.model.idCliente = this.$route.params.idCliente;

                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.file);

                let ret = null;

                if (vm.model.id) {
                    ret = await facade.updatePet(
                        formData,
                        vm.model.idCliente,
                        vm.model.id
                    );
                    this.$router.push({ name: "list-pet" });
                } else {
                    ret = await facade.createPet(formData, vm.model.idCliente);
                    vm.model.id = ret.data.data.id;
                    // this.$router.push({
                    //     name: "list-pet",
                    //     params: { id: vm.model.id }
                    // });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let pet = null;

        if (to.params.id) {
            pet = (await facade.getPet(to.params.id, to.params.idCliente)).data
                .data;
        }

        next(vm => vm.setData(pet));
    },
    watch: {
        async "model.tipo"(alterTipo) {
            if (alterTipo) {
                let res = await facade.listRacas({
                    tipo: alterTipo
                });
                this.racas = [];

                this.$nextTick(() => {
                    this.racas = res.data.data;
                });
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?51fddede